/**
 * Returns the display name for a registration based on its contestType.
 * - tournament → registration.tournament.name
 * - season/contest → registration.contest.name
 * Falls back to whichever is available if contestType is missing, then to the
 * registration's own `name` (denormalized event name) before the generic label —
 * so callers that only have a one-level-populated registration (tournament/contest
 * still bare ObjectIds, or soft-deleted) still show a meaningful name.
 */
export default function getRegistrationName(registration: any): string {
  if (!registration) return 'Registration';
  const contestType = registration.contestType?.toLowerCase();
  if (contestType === 'tournament') {
    return registration.tournament?.name || registration.contest?.name || registration.name || 'Registration';
  }
  if (contestType === 'season' || contestType === 'contest') {
    return registration.contest?.name || registration.tournament?.name || registration.name || 'Registration';
  }
  return registration.tournament?.name || registration.contest?.name || registration.name || 'Registration';
}
